import { auth } from './firebase';
import { crossAppActions } from './cross-app-actions';
import type { TenantID } from '../cross-app-shared/types/db';

export async function ensureStorageAccess(tenantID: TenantID) {
  const user = auth.currentUser;
  if (!user) throw new Error('Sign in again before uploading a file.');
  const hasAccess = (claims: Record<string, unknown>) =>
    Array.isArray(claims.tenantIds) && claims.tenantIds.includes(tenantID);
  if (hasAccess((await user.getIdTokenResult()).claims)) return;

  await crossAppActions.users.refreshStorageAccess({ tenantID });
  const refreshed = await user.getIdTokenResult(true);
  if (auth.currentUser !== user) throw new Error('Your sign-in changed. Please retry the upload.');
  if (!hasAccess(refreshed.claims)) {
    throw new Error('File access could not be refreshed. Sign out and sign in again, then retry the upload.');
  }
}
